import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIConfig } from "../config/APIConfig";

export const checkAuthAdmin = createAsyncThunk(
  "auth/checkAuthAdmin",
  async (_, { rejectWithValue }) => {
    try {
      const res = await APIConfig.get("/auth/admin/me", {
        withCredentials: true,
      });

      return res?.data?.data;
    } catch (err) {
      return rejectWithValue();
    }
  },
);

const initialState = {
  admin: null,
  loading: true,
  isAuthenticated: false,
};

const authSliceAdmin = createSlice({
  name: "authAdmin",
  initialState,
  reducers: {
    setAdmin: (state, action) => {
      state.admin = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
    },
    clearAdmin: (state) => {
      state.admin = null;
      state.isAuthenticated = false;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthAdmin.fulfilled, (state, action) => {
        state.admin = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
      })
      .addCase(checkAuthAdmin.rejected, (state) => {
        state.admin = null;
        state.isAuthenticated = false;
        state.loading = false;
      });
  },
});

export const { setAdmin, clearAdmin } = authSliceAdmin.actions;
export default authSliceAdmin.reducer;
